import styled from 'styled-components';

export const MobileHistoryInfoIconWrapperStyled = styled.div`
    width: 48px;
    height: 48px;
    font-size: 27px;
    margin-bottom: 12px;
`;
